import { getApiLicenseCheck } from '../api/sdk.gen';

export function LicenseChecker() {
  let hasUserValidLicense = false;

  function getHasUserValidLicense() {
    return hasUserValidLicense;
  }

  async function checkUserLicenseStatus() {
    const { data } = await getApiLicenseCheck();
    hasUserValidLicense = data ?? false;
  }

  return {
    getHasUserValidLicense,
    checkUserLicenseStatus,
  };
}
